import { USER_TOKEN_ADD, USER_TOKEN_REMOVE, USER_SESSION_EXPIRED, USER_TOKEN_DETAILS_UPDATE, APP_LOGIN_MENU } from '../../types'
import http from '@/utils/ajax'
import Router from '@/router'
import { initials } from '@/utils/name'
import StompClient from '@/websocket'
import { extractMenu } from '@/utils/extract'

const state = {
  token: '',
  timestamp: undefined,
  firstName: '',
  lastName: '',
  email: '',
  usrId: undefined,
  inactiveInterval: 0,
  isLogin: false,
  changePassword: false,
  twoFA: false,
  privileges: [],
  loginMessages: []
}

const getters = {
  userInitials: (state) => {
    return initials(state.firstName, state.lastName)
  },
  checkAccess: (state) => {
    return (privileges) => {
      let result = false
      if (privileges && privileges.length > 0) {
        for (var i = 0; i < privileges.length; i++) {
          const privilege = privileges[i]
          let filteredPrivileges = []
          // Privilege equals
          filteredPrivileges = state.privileges.filter(myPrivilege => myPrivilege === privilege)
          if (filteredPrivileges && filteredPrivileges.length > 0) {
            result = true
          }
        }
      }
      return result
    }
  }
}

const mutations = {
  [USER_TOKEN_ADD](state, data) {
    state.token = data.token
    state.timestamp = new Date()
    state.firstName = data.firstName
    state.lastName = data.lastName
    state.email = data.email
    state.usrId = data.usrId
    state.inactiveInterval = data.inactiveInterval
    state.isLogin = true
    state.changePassword = data.changePassword
    state.twoFA = data.twoFA
    state.privileges = data.privileges
    state.loginMessages = data.loginMessages
  },
  [USER_TOKEN_REMOVE](state) {
    state.token = ''
    state.timestamp = undefined
    state.firstName = ''
    state.lastName = ''
    state.email = ''
    state.usrId = undefined
    state.inactiveInterval = 0
    state.isLogin = false
    state.changePassword = false
    state.twoFA = false
    state.privileges = []
    state.loginMessages = []
  },
  [USER_TOKEN_DETAILS_UPDATE](state, data) {
    state.firstName = data.firstName
    state.lastName = data.lastName
    state.email = data.email
  }
}

function logoutCommit(context, forceReload) {
  context.commit(USER_TOKEN_REMOVE)
  if (!forceReload) {
    context.commit(USER_SESSION_EXPIRED)
  }
}
const actions = {
  async processLoginForm({ commit, dispatch }, response) {
    const { data } = response
    const commitForm = {
      token: response.headers['x-auth-token'],
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      usrId: data.usrId,
      inactiveInterval: data.inactiveInterval,
      changePassword: data.changePassword,
      twoFA: data.twoFA,
      privileges: data.privileges,
      loginMessages: data.messages
    }
    // Commit to store token
    commit(USER_TOKEN_ADD, commitForm)

    // Commit to extract out menu
    const menu = extractMenu(data._links)
    const commitMenu = {
      menu: menu,
      wsLink: data.wsLink,
      wsSubscribe: data.wsSubscribe
    }
    commit(APP_LOGIN_MENU, commitMenu)

    // Post Login Init
    dispatch('postLoginInit')
  },
  async logout(context, forceReload = false) {
    try {
      // Disconnect websocket
      StompClient().then(result => {
        result.disconnect()
      })
      const apiURL = context.rootState.app.menu.logout
      if (apiURL) {
        await http.post(apiURL)
      } else {
        console.log('Invalid API URL')
      }
    } catch (err) { }

    logoutCommit(context, forceReload)
    Router.push({ name: 'login' })

    if (forceReload) {
      window.location.reload()
    }
  }
}

export default {
  // It supports state, getters, mutations, actions
  state,
  getters,
  mutations,
  actions
}
